import { render } from "./Edit.vue?vue&type=template&id=0e1dae76"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/TasksCustomFields/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e1dae76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e1dae76', __exports__)) {
    api.reload('0e1dae76', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=0e1dae76", () => {
    api.rerender('0e1dae76', render)
  })

}


export default __exports__